var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", { staticClass: "header" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.$t("countrySelectorHeader")) + "\n\t"),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "countryList" },
      _vm._l(_vm.items, function (item) {
        return _c("CountrySelectorItemView", {
          key: item.k,
          tag: "li",
          attrs: { iso: item.iso, name: item.name, suggested: item.suggested },
          on: { select: _vm.selectCountry },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }